import React from "react";
import { Container } from "@mui/material";
import { ClinicalBudgetProvider } from "shared/providers/ClinicalBudget";
import { ClinicalBudgetStep } from "./components/stepper";

const ClinicalBudget: React.FC = () => {
  return (
    <ClinicalBudgetProvider>
      <Container maxWidth="xl" sx={{ p: 0 }}>
        <ClinicalBudgetStep />
      </Container>
    </ClinicalBudgetProvider>
  );
};

export { ClinicalBudget };

